import { render, staticRenderFns } from "./payoffPie.vue?vue&type=template&id=df318bd0&scoped=true&"
import script from "./payoffPie.vue?vue&type=script&lang=js&"
export * from "./payoffPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df318bd0",
  null
  
)

export default component.exports